import service from "../utils/axios";

// 获取首页数据分类
const getDataCategories = () => {
  return service.get("/home/data_categories");
};

// 获取首页统计数据
const getStats = () => {
  return service.get("/home/stats");
};

// 获取首页热门搜索词
const getHotWords = () => {
  return service.get("/documents/search/hot_words");
};

// 用户提交搜索
const getSearchResults = (data) => {
  return service.get("/documents/search", { params: data });
};

// 用户点击某条结果
const selectSearchResult = (data) => {
  return service.post("/documents/search/select", data);
};

export {
  getDataCategories,
  getStats,
  getHotWords,
  getSearchResults,
  selectSearchResult,
};
